/**
 * @generated SignedSource<<6481a8fe29153258cdcbde2dba616934>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainDocuments_order$data = {
  readonly orderRooms: ReadonlyArray<{
    readonly slots: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PassengerDocuments_slot">;
    }>;
  }>;
  readonly " $fragmentType": "OrderEditMainDocuments_order";
};
export type OrderEditMainDocuments_order$key = {
  readonly " $data"?: OrderEditMainDocuments_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainDocuments_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainDocuments_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderRoom",
      "kind": "LinkedField",
      "name": "orderRooms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PassengerSlot",
          "kind": "LinkedField",
          "name": "slots",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PassengerDocuments_slot"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "f1c418cb69a7a494cb07f5de2deaf2e3";

export default node;
